export default __webpack_public_path__ + "static/media/game_starter.a3b541fa.mp3";